import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FireflyStackedBarModule } from '../common/bars/stacked-bar/stacked-bar.module';
import { FireflyLegendModule } from '../common/legend/legend.module';
import { FireflyHorizontalStackedBarChartComponent } from './horizontal-stacked-bar-chart.component';

@NgModule({
  imports: [CommonModule, FireflyStackedBarModule, FireflyLegendModule],
  declarations: [FireflyHorizontalStackedBarChartComponent],
  exports: [FireflyHorizontalStackedBarChartComponent]
})
export class FireflyHorizontalStackedBarChartModule {}
